import { TFunction } from "i18next";
import { z } from "zod";

export const getDocumentFormSchema = (t: TFunction) => {
  return z.object({
    docTypeId: z
      .number({
        required_error: t("entities.entity.documents.errors.doc-type-required"),
        invalid_type_error: t("entities.entity.documents.errors.doc-type-required"),
      }),
    docNumber: z.string().min(1, { message: t("entities.entity.documents.errors.doc-number-required") }),
    issueDate: z.string().min(1, { message: t("entities.entity.documents.errors.issue-date-required") }),
    dueDate: z.string().min(1, { message: t("entities.entity.documents.errors.due-date-required") }),
    archive: z.string().transform(str => (str.trim() === "" ? null : str)).nullable().optional(),
  });
};

export type DocumentForm = z.infer<ReturnType<typeof getDocumentFormSchema>>;
